function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawTeddyBear = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1071.08 838.44",
    style: style
  }, props), React.createElement("path", {
    d: "M1058.89 601.22a197.3 197.3 0 0 1-16.41 32.55c0 .08-.1.17-.16.25a30.7 30.7 0 0 1-26 14H88.19c-67.75 0-110.2-69.94-76.23-125.81 61.13-100.5 118.89-240 49-336.14C-51.27 31.48 69.61 3.43 149.35.22a221.52 221.52 0 0 1 89.86 15.17c36.84 14.48 104.17 36.62 191.89 46.78 2.88.34 5.78.66 8.72 1a813.59 813.59 0 0 0 139.78 2.61c1.37-.07 2.74-.18 4.14-.28a806 806 0 0 0 136.73-21.92c2.91-.73 5.78-1.42 8.63-2.11 149.64-35.76 287.58 86.09 253.09 223.75-12.75 50.94-9.51 105.23 33 149.14 69.55 71.78 61.12 142.38 43.7 186.86z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M905.87 613.57H918a25 25 0 0 1 25 25v37.11h-62.13v-37.11a25 25 0 0 1 25-25z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M905.87 613.57H918a25 25 0 0 1 25 25v37.11h-62.13v-37.11a25 25 0 0 1 25-25z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 622.27,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 616.06,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 609.85,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 603.63,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 597.42,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 591.21,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 585,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 916.9,
    cy: 587.49,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 921.87,
    cy: 585,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 926.83,
    cy: 582.52,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 578.79,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 572.58,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 566.37,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 909.44,
    cy: 560.16,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M930.04 544.13c-1.23.18-2.47.31-3.71.39a28.56 28.56 0 0 0 3.21-3.3 21.22 21.22 0 0 0-3-5.83 10.22 10.22 0 0 1-4 1.26c-1.23.18-2.47.32-3.71.4a68.41 68.41 0 0 0 4.75-5 21.1 21.1 0 1 0 6.96 15.68 20.68 20.68 0 0 0-.32-3.63zM946.65 568.82a9.83 9.83 0 0 1-4.18 1.4c-1.23.18-2.47.31-3.71.39a36.4 36.4 0 0 0 3.68-3.82 12.44 12.44 0 1 0 4.21 2z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 901.99,
    cy: 587.49,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 897.02,
    cy: 585,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 892.05,
    cy: 582.52,
    r: 4.97,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M872.24 568.82a9.78 9.78 0 0 0 4.18 1.4c1.23.18 2.47.31 3.71.39a35.42 35.42 0 0 1-3.68-3.82 12.44 12.44 0 1 1-4.21 2z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M905.87 617.3H918a25 25 0 0 1 25 25v32.87a4.24 4.24 0 0 1-4.24 4.24h-53.65a4.24 4.24 0 0 1-4.24-4.24V642.3a25 25 0 0 1 25-25z",
    fill: "#3f3d56"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M930.42 545.49a18.83 18.83 0 0 1-1.6 1.52c.57 0 1.13-.09 1.7-.15.02-.46-.05-.92-.1-1.37zM921.36 539.55c1.25-.08 2.48-.21 3.72-.39a12 12 0 0 0 3.23-.88 21.92 21.92 0 0 0-1.74-2.87 7.52 7.52 0 0 1-2 .85 28.79 28.79 0 0 1-3.21 3.29zM890.81 550.22a21.08 21.08 0 0 1 32.5-17.76l.32-.34a21.1 21.1 0 1 0-27.82 31.73 21 21 0 0 1-5-13.63z"
  })), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M938.76 573.09c1.24-.08 2.48-.21 3.71-.39a9.7 9.7 0 0 0 4.18-1.4 12.43 12.43 0 0 1 5 8.8 11.38 11.38 0 0 0 .07-1.31 12.38 12.38 0 0 0-5-10 9.83 9.83 0 0 1-4.18 1.4l-1 .12a25.37 25.37 0 0 1-2.78 2.78zM939.26 568.85a10.19 10.19 0 0 1 1.24.09c.65-.69 1.29-1.43 1.94-2.15a12.4 12.4 0 0 0-15.6 12c0 .42 0 .83.06 1.24a12.42 12.42 0 0 1 12.36-11.18z"
  })), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M880.13 573.09c-1.24-.08-2.48-.21-3.71-.39a9.65 9.65 0 0 1-4.18-1.4 12.43 12.43 0 0 0-5 8.8 11.38 11.38 0 0 1-.07-1.31 12.38 12.38 0 0 1 5-10 9.78 9.78 0 0 0 4.18 1.4l1 .12a23.67 23.67 0 0 0 2.78 2.78zM879.63 568.85a10.36 10.36 0 0 0-1.25.09c-.64-.69-1.28-1.43-1.93-2.15a12.4 12.4 0 0 1 15.6 12c0 .42 0 .83-.06 1.24a12.42 12.42 0 0 0-12.36-11.18z"
  })), React.createElement("path", {
    d: "M219.08 670.09h-152a6.46 6.46 0 0 1-6.46-6.46v-71.91a6.45 6.45 0 0 1 9.23-5.83c43.69 20.72 90.69 27.83 146.33.33a6.47 6.47 0 0 1 9.36 5.77v71.66a6.46 6.46 0 0 1-6.46 6.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M219.08 670.09h-152a6.46 6.46 0 0 1-6.46-6.46v-71.91a6.45 6.45 0 0 1 9.23-5.83c43.69 20.72 90.69 27.83 146.33.33a6.47 6.47 0 0 1 9.36 5.77v71.66a6.46 6.46 0 0 1-6.46 6.44z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 603.61,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 589.21,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 574.81,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 560.41,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 546.01,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 531.61,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 142.03,
    cy: 517.21,
    rx: 9,
    ry: 11.78,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M175.72 418.67a42.85 42.85 0 0 0 3.35-4.94l-23.65-3.88 25.58.19a43.24 43.24 0 0 0 .82-34.16l-34.28 17.8 31.64-23.26a43.11 43.11 0 1 0-71.2 48.25 43 43 0 0 0-4.92 7.86l30.7 15.95-32.73-11a43.11 43.11 0 0 0 6.95 40.49 43.11 43.11 0 1 0 67.77 0 43.14 43.14 0 0 0 0-53.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M98.72 445.32a43 43 0 0 0 9.23 26.66 43.11 43.11 0 1 0 67.77 0c5.82-7.34-77-31.5-77-26.66z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M219.08 673.9h-152a6.47 6.47 0 0 1-6.46-6.47v-75.71a6.45 6.45 0 0 1 9.23-5.83c43.67 20.72 78.3 44.87 146.33.31 4-2.63 9.36 1 9.36 5.77v75.46a6.47 6.47 0 0 1-6.46 6.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M289.84 694.11l21.56 35.17s51.05 22.69 113.45-35.17 0-107.77 0-107.77l-76 19.58z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M289.84 694.11l21.56 35.17s51.05 22.69 113.45-35.17 0-107.77 0-107.77l-76 19.58z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M389.45 786.22l-29.68 12.53c-31.17 13.17-62.39 26.36-94.59 36.77-8.83 2.86-19.52 5.17-26.55-.88s-6.31-17.18-2.59-25.59c1.38-3.12 3.1-6.13 3.78-9.47.9-4.4-.09-8.94-.75-13.39-1-6.81-1.18-13.87.7-20.49s6-12.8 12.1-16.06c4.49-2.42 10.75-2.8 14.16 1 2.79 3.1 2.75 7.83 4.76 11.49 2.67 4.84 8.67 7.07 14.19 6.83s10.73-2.52 15.8-4.75c40.12-17.67 80.41-35.44 117.45-58.9 6.41-4.05 12.73-8.29 19.48-11.74a96.61 96.61 0 0 1 20.42-7.71 3.25 3.25 0 0 1 2.38 0 3.33 3.33 0 0 1 1.24 2.54c1.53 9.75 3.06 19.51 3.95 29.34.7 7.71 3.33 21.3.32 28.62-2.47 6-15.44 11-21 14.1-8.36 4.59-16.94 8.78-25.61 12.75-9.93 4.54-19.94 8.78-29.96 13.01z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M389.45 786.22l-29.68 12.53c-31.17 13.17-62.39 26.36-94.59 36.77-8.83 2.86-19.52 5.17-26.55-.88s-6.31-17.18-2.59-25.59c1.38-3.12 3.1-6.13 3.78-9.47.9-4.4-.09-8.94-.75-13.39-1-6.81-1.18-13.87.7-20.49s6-12.8 12.1-16.06c4.49-2.42 10.75-2.8 14.16 1 2.79 3.1 2.75 7.83 4.76 11.49 2.67 4.84 8.67 7.07 14.19 6.83s10.73-2.52 15.8-4.75c40.12-17.67 80.41-35.44 117.45-58.9 6.41-4.05 12.73-8.29 19.48-11.74a96.61 96.61 0 0 1 20.42-7.71 3.25 3.25 0 0 1 2.38 0 3.33 3.33 0 0 1 1.24 2.54c1.53 9.75 3.06 19.51 3.95 29.34.7 7.71 3.33 21.3.32 28.62-2.47 6-15.44 11-21 14.1-8.36 4.59-16.94 8.78-25.61 12.75-9.93 4.54-19.94 8.78-29.96 13.01z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M387.69 728.34c-5.65 5.08-11.81 9.66-16.67 15.49-5.89 7.07-9.61 15.67-12.83 24.29a287.34 287.34 0 0 0-8.84 27.93c-2.07 7.88-3.88 16.06-8.45 22.8s-12.75 11.8-20.71 10c-6.95-1.53-11.93-7.7-15.12-14.07s-5.24-13.36-9.38-19.16c-4.63-6.4-11.85-11.4-14.07-19.07-2.34-8.06 1.87-17 8.43-22.18s15-7.45 23.3-8.73a6.33 6.33 0 0 0 2.6-.77c1.83-1.18 2-3.76 1.93-5.94a386 386 0 0 1 9.31-91.71c2-9 4.38-18 8.74-26 7.86-14.54 23.83-25.81 40.2-23.54 12 1.66 22.28 10.29 28.39 20.79s8.58 22.7 9.94 34.77 4.91 31.54-.93 42.59a120.92 120.92 0 0 1-25.84 32.51zM578.07 292.7c-1 7.76-1.78 16.27 2.47 22.85 2.59 4 6.73 6.76 10.82 9.23a194.52 194.52 0 0 0 18.37 9.77 3.72 3.72 0 0 1 1.81 1.36 3.64 3.64 0 0 1-.07 2.71 581.43 581.43 0 0 1-27.37 74.1 9.54 9.54 0 0 1-2.49 3.78 9.28 9.28 0 0 1-4.15 1.54 122.69 122.69 0 0 1-85.75-15.63 43.64 43.64 0 0 1-8.57-6.45 37.73 37.73 0 0 1-6-8.37c-12-21.8-10.62-48.2-8.93-73a63.63 63.63 0 0 0 20.8-1.37 28.24 28.24 0 0 0 9.5-3.78c5.65-3.82 8.68-10.41 11.16-16.77a233.6 233.6 0 0 0 9.41-30.13c.88-3.66 41.92 3.7 46.05 4.62 4.55 1 15.39 1.69 16.87 7 1.3 4.57-3.26 13.64-3.93 18.54z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M578.07 292.7c-1 7.76-1.78 16.27 2.47 22.85 2.59 4 6.73 6.76 10.82 9.23a194.52 194.52 0 0 0 18.37 9.77 3.72 3.72 0 0 1 1.81 1.36 3.64 3.64 0 0 1-.07 2.71 581.43 581.43 0 0 1-27.37 74.1 9.54 9.54 0 0 1-2.49 3.78 9.28 9.28 0 0 1-4.15 1.54 122.69 122.69 0 0 1-85.75-15.63 43.64 43.64 0 0 1-8.57-6.45 37.73 37.73 0 0 1-6-8.37c-12-21.8-10.62-48.2-8.93-73a63.63 63.63 0 0 0 20.8-1.37 28.24 28.24 0 0 0 9.5-3.78c5.65-3.82 8.68-10.41 11.16-16.77a233.6 233.6 0 0 0 9.41-30.13c.88-3.66 41.92 3.7 46.05 4.62 4.55 1 15.39 1.69 16.87 7 1.3 4.57-3.26 13.64-3.93 18.54z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M425.09 503.06c26-1.26 51.42 7.45 75.77 16.75s49.79 18.23 75.79 20c1.83-6.67 3.78-13.37 6.23-19.84a91.85 91.85 0 0 1 9.3-18.5c3.15-4.7 6.88-9.07 9.28-14.18 4.73-10.09 3.81-21.76 3.27-32.88s4.91-46.68 11.28-55.83c-4.51-6.86-9.11-3.36-13.62-10.21-2.4-3.67-11.45 5.79-15 3.16-3.73-2.78-8.34-4.08-12.88-5.14-25.29-6-51.86-6.38-76.43-14.85-6.48-2.23-13.44-5-19.93-2.87a28 28 0 0 0-7.11 4l-15.32 10.85c-1.42 1-2.3.92-3 2.53a90.13 90.13 0 0 0-6.84 26.95c-1 10.83-.09 21.76-1.31 32.56a137.49 137.49 0 0 1-9.46 35.87 235.25 235.25 0 0 1-10.02 21.63z",
    fill: "#f86d70"
  }), React.createElement("circle", {
    cx: 557.58,
    cy: 234.65,
    r: 62.4,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M475.48 309.42q.75 28 3.18 55.89c.33 3.84.85 8 3.65 10.68a48.5 48.5 0 0 1-20.64 7.64c-4.46-12.22-9-24.89-8.16-37.88.64-10.08 4.3-19.66 5.19-29.7.26-2.87-.49-6.85 2.5-8.4 1.14-.59 14.28 1.64 14.28 1.77zM439.76 493.77c-4.29.39-8 3-11.51 5.49-41.71 30.32-78.71 67.43-107.55 110.21-7.18 10.65-13.86 21.65-21.5 32-20.28 27.45-46.81 49.6-73.9 70.34 7.07-.32 15-.12 22.08-.44 3.9-.18 7.87-.35 11.67.56s7.49 3.09 9.32 6.54c1.69 3.18 2.14 7.65 5.51 8.92a9.53 9.53 0 0 0 4.66.06 58.12 58.12 0 0 1 33.3 5.32 122.31 122.31 0 0 1 3.82-25.37c1.2-4.78 2.76-9.46 4.36-14.13 3.59-10.45 7.42-20.91 13.28-30.29a80 80 0 0 1 26.31-25.94 26.84 26.84 0 0 1 9.84-4c8.81-1.29 17.31 5.08 21.38 13s4.69 17.1 5.23 26l2 32.71c.24 3.95.55 8.12 2.77 11.4 1.74-3.36 5.92-4 9.17-5.94 6.21-3.69 13.18-7.52 20.26-6.07 7.89 1.6 13 9.17 16.51 16.41a126.26 126.26 0 0 1 11.77 40.34c14.75-7.9 24.34-22.93 27.84-39.3 2-9.25 1.65-18.87 3.38-28.17a65.45 65.45 0 0 1 16.41-32.54c18.63-19.95 48.27-26.78 66.6-47 2.41-2.67 4.67-5.72 5.11-9.29.52-4.27-1.68-8.42-1.78-12.72-.16-7.28 5.46-13.18 10-18.85a84.6 84.6 0 0 0 11-17.7c1.54-3.35 2.89-7 2.57-10.64s-2.72-7.42-6.34-8.16c-6.62-1.35-13.2 7.35-19.15 4.13a10.16 10.16 0 0 1-3.56-3.9 60.72 60.72 0 0 1-7.83-20.07c-15-5.47-30.79-7.41-46.25-11.33-6.58-1.67-13-3.89-19.52-5.8-18.43-5.41-38.05-5.49-57.26-5.78z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M425.09 503.06c26-1.26 51.42 7.45 75.77 16.75s49.79 18.23 75.79 20c1.83-6.67 3.78-13.37 6.23-19.84-2.33-1.33-5.16-2.27-7.18-3.24a353.05 353.05 0 0 0-38-15.74 359.28 359.28 0 0 0-80.71-17.95c-7.24-.76-14.52-1.28-21.8-1.58a235.25 235.25 0 0 1-10.1 21.6z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M425.09 503.06c26-1.26 51.42 7.45 75.77 16.75s49.79 18.23 75.79 20c1.83-6.67 3.78-13.37 6.23-19.84-2.33-1.33-5.16-2.27-7.18-3.24a353.05 353.05 0 0 0-38-15.74 359.28 359.28 0 0 0-80.71-17.95c-7.24-.76-14.52-1.28-21.8-1.58a235.25 235.25 0 0 1-10.1 21.6z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M607.78 336.92a47.57 47.57 0 0 1 49.44 45.3 80.79 80.79 0 0 1-1.68 18.26c-5.92 32.25-18 64.95-10.81 96.94 2.11 9.44 5.87 18.56 6.57 28.2a91 91 0 0 1-.43 14l-3.84 46.13c5.4 6 12.65 11.42 18.56 17s11.29 12.11 13.19 20a45.17 45.17 0 0 1 .78 12.67c-.1 2.16-.34 4.54-1.91 6s-4.85 1.1-5.16-1c-1.08 2.82-5.55 2.58-7.54.31s-2.32-5.5-2.91-8.47a38.75 38.75 0 0 0-5.7-13.88c-1.27 1.88-1 4.35-1.25 6.6s-1.59 4.86-3.86 4.85c-2.74 0-3.78-3.53-4.15-6.25-.51-3.83-1.32-7.73-3.36-11s-5.54-5.89-9.41-5.93a3.4 3.4 0 0 1 2.33 2.54 25.08 25.08 0 0 1-12.35 1.28 15.39 15.39 0 0 1-6.67-2.45c-3.34-2.37-5.12-6.44-5.75-10.49s-.3-8.17-.25-12.27c.2-17.1-4.84-33.77-9.83-50.13-3.84-12.58-7.27-25-6.1-38.08.56-6.25 2.1-12.36 3-18.57 3.23-22.5-2-46.42 6.42-67.55.88-2.23 1.94-4.54 1.66-6.92a12 12 0 0 0-2.81-5.63 72.21 72.21 0 0 0-14.42-14.16 15.21 15.21 0 0 0 2.36-4.92c3.79-14.47 6.57-30.65 15.88-42.38z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M614.14 346.59a213 213 0 0 0-4.6 24.88c-1.8 17.25 1.92 16.05-2.62 32.78-11.07-5.82-23.5 7.3-34.57 1.48-1-.55-2.2-1.25-2.4-2.41a4 4 0 0 1 1.1-2.84 121.87 121.87 0 0 0 16.22-30.36c3.11-8.57 5.27-17.5 9.24-25.7 2.34-4.85 5.47-9.56 10.11-12.29 2.57-1.51 13-4.34 14 .66.27 1.45-3 4.27-3.75 5.63a31 31 0 0 0-2.73 8.17z",
    fill: "#f86d70"
  }), React.createElement("circle", {
    cx: 588.25,
    cy: 385.08,
    r: 43.12,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 715.86,
    cy: 385.08,
    r: 43.12,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 705.37,
    cy: 390.84,
    rx: 32.64,
    ry: 37.36,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 598.74,
    cy: 390.84,
    rx: 32.64,
    ry: 37.36,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M805.62 560.81c-1.24 13.42-12 26.52-25.48 26.6-6 0-11.67-2.35-17-5.08-4.62-2.37-9.18-5.11-12.53-9.08-.49-.58-.94-1.17-1.37-1.78-5.34-7.58-6.46-17.64-11.11-25.8-8.35-14.67-26.19-20.61-42.61-24.52a505 505 0 0 0-52.49-9.62c-12-1.56-24.19-2.68-36.21-1.2-25.58 3.15-48.68 17.83-74.15 21.19-.86.11-1.72.21-2.59.3-8 .8-16.11.4-24.13 1.14-13.35 1.23-26.49 5.63-39.87 4.72s-27.83-9.63-28.78-23c-.67-9.42 5.73-18.23 13.83-23.08s17.67-6.5 27-7.85c24.77-3.59 50.2-5.87 73-16.11 8.16-3.66 15.9-8.31 24.33-11.29a50.19 50.19 0 0 1 11.61-2.67 30.89 30.89 0 0 1 14.64 1.87l-12 4.56 117.17-8.27 4.62-.32c5.55-.39 11.2-.78 16.63.45 9.34 2.12 17 8.82 22.91 16.38s10.32 16.15 15.86 24c7.79 11 17.66 20.36 25.65 31.2s14.3 23.85 13.07 37.26z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M751.01 543.55a206.35 206.35 0 0 1-1.73 27.92c-5.34-7.58-6.46-17.64-11.11-25.8-8.35-14.67-26.19-20.61-42.61-24.52a505 505 0 0 0-52.49-9.62c-12-1.56-24.19-2.68-36.21-1.2-25.58 3.15-48.68 17.83-74.15 21.19 5.54-39.56 25.55-64.9 54.45-77.85 15.69-7 34-10.4 54.09-10.4 24.66 0 47.41 1 65.74 8.56 26.72 11 44.02 35.88 44.02 91.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M745.39 547.54c0 21.13-2.53 37.65-7.15 50.55-11.34 31.63-35.19 41.54-64.87 44.52-10 1-20.61 1.22-31.65 1.22a143.16 143.16 0 0 1-41.13-5.72c-24.75-7.45-45.06-22.36-55.39-45.62-5.57-12.52-8.24-27.45-7.16-44.95 4.14-66.76 46.42-96.32 103.68-96.32s103.67 5.93 103.67 96.32z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 652.06,
    cy: 430.57,
    r: 80.93,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 652.06,
    cy: 425.84,
    r: 80.93,
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 641.72,
    cy: 399.56,
    r: 4.14,
    fill: "#fbbebe"
  }), React.createElement("circle", {
    cx: 661.8,
    cy: 399.56,
    r: 4.14,
    fill: "#fbbebe"
  }), React.createElement("ellipse", {
    cx: 652.06,
    cy: 435.59,
    rx: 42.24,
    ry: 27.22,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 652.06,
    cy: 435.59,
    rx: 39.88,
    ry: 25.7,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M600.59 638.11c-24.75-7.45-45.06-22.36-55.39-45.62a33.19 33.19 0 0 1 10.86-1.83c21.11 0 38.92 20.03 44.53 47.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M600.07 660.67c0 36.37-20.76 65.86-46.37 65.86-17.35 0-32.47-13.52-40.42-33.56a87.83 87.83 0 0 1-6-32.3c0-36.38 20.77-65.87 46.38-65.87 23.11 0 42.28 24 45.79 55.46a91 91 0 0 1 .62 10.41z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M600.07 660.67c0 36.37-20.76 65.86-46.37 65.86-17.35 0-32.47-13.52-40.42-33.56 1.26-26.33 27.86-47.37 60.5-47.37a71.9 71.9 0 0 1 25.76 4.62 91 91 0 0 1 .53 10.45z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 577.33,
    cy: 697.29,
    rx: 60.55,
    ry: 49.33,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 581.9,
    cy: 700.39,
    rx: 55.97,
    ry: 46.23,
    fill: "#2f2e41"
  }), React.createElement("ellipse", {
    cx: 601.84,
    cy: 682.52,
    rx: 9.75,
    ry: 12.18,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 601.84,
    cy: 682.52,
    rx: 8.27,
    ry: 10.34,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 572.9,
    cy: 692.86,
    rx: 10.25,
    ry: 10.93,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 572.9,
    cy: 692.86,
    rx: 8.86,
    ry: 9.45,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 556.95,
    cy: 717.67,
    rx: 10.93,
    ry: 8.88,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 556.95,
    cy: 717.67,
    rx: 9.45,
    ry: 7.68,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 663.25,
    cy: 756.69,
    rx: 24.98,
    ry: 13.06,
    transform: "rotate(-41.01 589.787 827.437)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 663.25,
    cy: 756.69,
    rx: 23.35,
    ry: 12.2,
    transform: "rotate(-41.01 589.787 827.437)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M738.24 598.09c-11.34 31.63-35.19 41.54-64.87 44.52 4.8-29.1 23.19-50.77 45.14-50.77a35.19 35.19 0 0 1 19.73 6.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M768.43 660.67a86.88 86.88 0 0 1-7.09 35c-8.2 18.54-22.73 30.86-39.28 30.86-25.61 0-46.37-29.49-46.37-65.86a93 93 0 0 1 .55-10.25c3.47-31.51 22.66-55.62 45.82-55.62 25.61 0 46.37 29.49 46.37 65.87z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M761.34 695.52v.15c-8.2 18.54-22.73 30.86-39.28 30.86-25.61 0-46.37-29.49-46.37-65.86a93 93 0 0 1 .55-10.25 72.1 72.1 0 0 1 24.55-4.2c33.44 0 60.55 22.05 60.55 49.3z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 698.43,
    cy: 697.29,
    rx: 60.55,
    ry: 49.33,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 693.26,
    cy: 700.39,
    rx: 55.38,
    ry: 46.23,
    fill: "#2f2e41"
  }), React.createElement("ellipse", {
    cx: 673.91,
    cy: 682.52,
    rx: 9.92,
    ry: 12.41,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 673.91,
    cy: 682.52,
    rx: 8.27,
    ry: 10.34,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 702.86,
    cy: 692.86,
    rx: 10.25,
    ry: 10.93,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 702.86,
    cy: 692.86,
    rx: 8.86,
    ry: 9.45,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 718.81,
    cy: 717.67,
    rx: 10.93,
    ry: 8.88,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 718.81,
    cy: 717.67,
    rx: 9.45,
    ry: 7.68,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 741.42,
    cy: 756.69,
    rx: 13.06,
    ry: 24.98,
    transform: "rotate(-48.99 675.494 812.066)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 741.42,
    cy: 756.69,
    rx: 12.2,
    ry: 23.35,
    transform: "rotate(-48.99 675.494 812.066)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M464.03 311.46a49.23 49.23 0 0 0-30.94-.17c-4.91 1.61-9.76 4.17-12.68 8.45-2.34 3.43-3.22 7.63-4 11.7q-3.72 18.48-7.22 37c-2.7 14.25-.43 28.85 2.69 43s5.62 28.7 7.4 43.21a80.4 80.4 0 0 1 .78 16.68c-.54 6.28-2.43 12.56-1.42 18.78 1.86 11.43 12.61 18.92 22.43 25.06 3.63 10.74 15 16.5 25 21.79a442.47 442.47 0 0 1 59.92 38.08c6.69 5 13.3 10.33 20.89 13.88 7.1 3.33 14.82 5 22.48 6.72l24 5.26c7.14-1 15-3 21.49-6.16 3.78-1.87 7.95-5.28 7-9.38-.67-2.76-3.42-4.4-5.92-5.73-8-4.23-16-8.5-24.75-10.62-4.84-1.18-9.82-1.68-14.73-2.58a71 71 0 0 1-15.45-4.55c-12.39-5.37-22.47-14.85-32.27-24.15-9.27-8.78-17.45-18.12-26.34-27.28a155.61 155.61 0 0 0-12.97-11.23 337.69 337.69 0 0 1-28.26-26.15c-5-5.22-1.88-14.18-1.43-21.42.66-10.5-1.72-20.92-3.72-31.25-1-5.16-1.9-10.4-1.57-15.64.5-8 3.81-15.48 6.26-23.09a110.88 110.88 0 0 0 3.84-51.75c-1-6.19-2.12-12.4-.51-18.46z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M611.33 232.46c17.32-3.24 25.73-25.15 20.72-42.05s-19.1-29.34-33.12-40c-22.89-17.44-48.7-33.19-77.39-35.3s-60.38 13.68-68 41.41c-4.94 17.95.61 37.64-4.92 55.42-8 25.68-36.49 40.07-46.88 64.88-12.33 29.48 4.32 62.22 8.8 93.86 8.06 57-30.09 117.07-85.14 134 20.34 2.81 41 5.24 61.35 2.64s40.71-10.75 54.32-26.12c6.45-7.29 11.6-16.31 20.31-20.66 5.2-2.59 11.11-3.22 16.78-4.46 32.85-7.16 58.86-38.3 60.07-71.89.88-24.39-9.86-47.74-11.84-72.07-2.18-26.87 7.24-53.35 24.1-74.12 22.36-27.53 33.15-.36 60.84-5.54z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M632.05 191.55c-5-16.9-19.1-29.35-33.12-40a273.69 273.69 0 0 0-23.85-16.42c2.3 1.67 4.58 3.37 6.83 5.08 14 10.67 28.12 23.13 33.13 40s-3.4 38.81-20.73 42.05c-27.68 5.18-38.48-22-60.84 5.53-16.86 20.77-26.28 47.25-24.09 74.12 2 24.33 12.71 47.68 11.83 72.07-1.21 33.59-27.22 64.73-60.06 71.89-5.68 1.24-11.59 1.87-16.79 4.46-8.71 4.35-13.86 13.37-20.31 20.66-13.61 15.37-33.95 23.52-54.31 26.12a153.87 153.87 0 0 1-25.57 1 110.79 110.79 0 0 1-18.77 7.74c20.34 2.81 41 5.25 61.35 2.65s40.71-10.75 54.32-26.13c6.45-7.29 11.6-16.3 20.31-20.65 5.2-2.6 11.11-3.22 16.78-4.46 32.85-7.17 58.86-38.3 60.07-71.9.88-24.39-9.86-47.74-11.84-72.06-2.18-26.87 7.24-53.36 24.1-74.12 22.36-27.53 33.15-.36 60.84-5.53 17.32-3.29 25.73-25.2 20.72-42.1z",
    opacity: 0.15
  }));
};

UndrawTeddyBear.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawTeddyBear;